import { curry } from 'ramda';

export const CREATE_NEW_KEY = 'CREATE_NEW_KEY';
export const createNewKey = curry((domain, useBasicAuth) => ({
  type: CREATE_NEW_KEY,
  domain,
  useBasicAuth,
}));

export const DISCARD_NEW_KEY = 'DISCARD_NEW_KEY';
export const discardNewKey = curry((domain, useBasicAuth) => ({
  type: DISCARD_NEW_KEY,
  domain,
  useBasicAuth,
}));

export const UPDATE_NEW_KEY = 'UPDATE_NEW_KEY';
export const updateNewKey = curry((domain, key) => ({
  type: UPDATE_NEW_KEY,
  domain,
  key,
}));

export const REMOVE_KEY = 'REMOVE_KEY';
export const removeKey = curry((domain, path) => ({
  type: REMOVE_KEY,
  domain,
  path,
}));

export const UPDATE_KEY = 'UPDATE_KEY';
export const updateKey = curry((domain, key) => ({
  type: UPDATE_KEY,
  domain,
  key,
}));
